// extracted by mini-css-extract-plugin
export default {"container":"ptKuyNYUyDmgEAJB9wl1"};